import type { MarcadorPedido } from "./tipos"

/** Espaço horizontal entre etiquetas do mesmo endereço, exibidas lado a lado. */
export const ESPACO_ENTRE_PINS = 4

/** Container que põe as etiquetas do mesmo endereço lado a lado, alinhadas pela ponta. */
export const grupoStyle = {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    gap: `${ESPACO_ENTRE_PINS}px`,
} as const

/**
 * Agrupa os pedidos que caem no mesmo endereço (mesma coordenada, ~1 m de
 * tolerância) para que sejam desenhados lado a lado em vez de sobrepostos.
 */
export function agruparPorEndereco(marcadores: MarcadorPedido[]): MarcadorPedido[][] {
    const grupos = new Map<string, MarcadorPedido[]>()
    marcadores.forEach(m => {
        const chave = `${m.latitude.toFixed(5)},${m.longitude.toFixed(5)}`
        const grupo = grupos.get(chave)
        if (grupo) grupo.push(m)
        else grupos.set(chave, [m])
    })
    return Array.from(grupos.values())
}
